module.exports = __webpack_public_path__ + "static/media/Sports1.723be31b.webp";